<template>
  <div>
    <MenuMovilTP />
    <main class="container dkt mb-4 px-0 px-md-3 fc">
      <Titulo
        :titulo2="institucion.nombreCorto"
        :titulo3="tipoInstitucion"
        tipoEncabezado="FICHA_INSTITUTO"
        :volverA="origenRedirect"
        :datosContacto="datosContactame"
        @descargar="descargarFicha"
      />
      <div class="col mb-3 px-0">
        <Iconos
          :institucion="institucion"
          tipoInstitucion="TECNICO_PROFESIONAL"
        />
        <DetallesInstitucion
          :institucion="institucion"
          tipoInstituto="TECNICO_PROFESIONAL"
        />
      </div>
    </main>
    <MenuMovilUni />
  </div>
</template>

<script>
import Busqueda from "@/utils/Busqueda.js";
import Titulo from "@/components/generales/paginas/TituloFicha";
import ApiTecnicoProf from "@/services/ApiTecnicoProf";
import Iconos from "@/components/fichaInstitucion/Iconos";
import DetallesInstitucion from "@/components/fichaInstitucion/DetallesInstitucion";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import { PdfDocument } from "@/utils/ConstructorPDF.js";
import MixinsIconos from "@/mixins/iconosInstituciones.js";

export default {
  name: "FichaInstitucion",
  components: {
    Titulo,
    Iconos,
    DetallesInstitucion,
    MenuMovilTP,
    MenuMovilUni
  },
  mixins: [MixinsIconos],
  data() {
    return {
      institucion: {},
      origenRedirect: ""
    };
  },
  created() {
    this.getDatosFicha();
  },
  computed: {
    tipoInstitucion() {
      if (this.institucion.tipoInstitucion === "CENTRO_FORMACION_TECNICA") {
        return "CENTRO DE FORMACIÓN TÉCNICA";
      } else {
        return this.limpiarNombreTipoInstitucion(
          this.institucion.tipoInstitucion
        );
      }
    },
    datosContactame() {
      let datosContacto = {
        codigoIntitucion: this.institucion.codigo
      };
      return datosContacto;
    }
  },
  methods: {
    async getDatosFicha() {
      this.$emit("cargar");
      let idInstitucion = this.$route.params.idInstitucion;
      this.origenRedirect = this.$route.params.origen;
      let data = await ApiTecnicoProf.getFichaInstitucion(idInstitucion, true);
      if (data) {
        this.institucion = data;
      }
      this.$emit("cargado");
    },
    limpiarNombreTipoInstitucion(texto) {
      return Busqueda.limpiarNombreTipoInstitucion(texto);
    },
    descargarFicha() {
      let nombreDocumento = this.institucion.nombreCorto;

      let titulo = {
        institucion: this.institucion.nombreCorto,
        tipoInstitucion: this.tipoInstitucion
      };
      let iconos = {
        tipoInstitucion: "TECNICO_PROFESIONAL",
        logoInstitucion: this.getBase64Image(this.institucion.logoBase64),
        acreditacionInstitucional: this.textoAcreditacion(
          "TECNICO_PROFESIONAL",
          this.institucion.acreditado,
          this.institucion.acreditacion.anios,
          this.institucion.observacionAcreditacionCNA
        ),
        periodoAcreditacion: this.institucion.acreditacion.periodo,
        areasAcreditadas:
          this.institucion.areasAcreditadas &&
          this.institucion.areasAcreditadas.length > 0
            ? this.institucion.areasAcreditadas.slice()
            : ["Sin áreas acreditadas"],
        matriculaPregrado: this.institucion.matriculaTotalPregrado,
        matriculaPostgrado: this.institucion.matriculaTotalPostgrado,
        beneficiosEstatales: this.institucion.beneficiosEstatales,
        presenciaRegional: this.institucion.presenciaRegional.slice(),
        observacionAcreditacionCNA: this.institucion.observacionAcreditacionCNA,
        acreditacionEspecialPandemiaCNA:
          this.institucion.acreditado &&
          this.institucion.acreditacion.anios === 0
      };

      PdfDocument.init();
      PdfDocument.setTitulo("TECNICO_PROFESIONAL", titulo);
      PdfDocument.setIconosInstituciones(iconos);
      PdfDocument.setDisclaimersAdicionales(
        iconos.observacionAcreditacionCNA,
        iconos.acreditacionEspecialPandemiaCNA,
        "TECNICO_PROFESIONAL"
      );
      PdfDocument.setServiciosEstudiantiles(
        this.institucion.serviciosEstudiantiles,
        "TECNICO_PROFESIONAL"
      );
      PdfDocument.setInfraestructuraEquipamiento(
        this.institucion.infraestructurasEquipamientos
      );
      PdfDocument.openSinglePage(nombreDocumento);
      PdfDocument.reset();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/BuscadoresTP/FichaInstitucion.vue